var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStoreSm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_52-google-play"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.472,227.608c17.25,12.85,17.25,41.79,1.08,54.641l-45.509,25.77l-67.441-53.09l67.607-52.077     L430.472,227.608z",
    style: {
      fill: "#FFC801"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.396,307.769l-0.01-0.01h-0.01l-67.835-52.801l-0.021-0.02l-0.01,0.01l0.021,0.021    l-0.021-0.021l-0.03-0.03l-0.239,0.181l-249.79,190.25v7.95c-0.001,10.503,2.457,21.705,10.845,25.595    c11.052,5.125,27.177-4.892,27.177-4.892L386.396,307.769z",
    style: {
      fill: "#F93647"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "318.242,255.099 68.452,445.349 68.452,60.588 318.182,255.019    ",
    style: {
      fill: "#00D3FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.452,56.738v3.85l249.729,194.431l0.061,0.08l0.239-0.181l0.021-0.01l0.1-0.08l67.607-51.685    c0,0-217.433-129.992-280.465-167.482c-2.742-1.631-9.313-5.768-17.192-3.188C79.113,35.565,68.452,46.793,68.452,56.738z",
    style: {
      fill: "#00EF77"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreSm);
export default __webpack_public_path__ + "static/media/play-store-sm.ad666a076a165da2e62cf76c1fc5fa7e.svg";
export { ForwardRef as ReactComponent };